import { RouteEntity } from 'Models/Entities';
import { compareFnByNumberAsc } from 'Util/_HumanWritten/SortUtils';
import { JourneyElementsDto } from '../Types/JourneyElementsDto';

export const getRoutesByLocations = (
	journeyElements: JourneyElementsDto,
	startLocationId: string,
	endLocationId: string,
	orgId?: string | null,
): RouteEntity[] => {
	const { routes } = journeyElements;
	const filteredRoutes = orgId ? routes?.filter(x => x.organisationIds?.includes(orgId) ?? true) : routes;

	if (filteredRoutes.length === 0) {
		return [];
	}

	const validRoutes = new Set<RouteEntity>();

	for (const route of filteredRoutes) {
		// Need to consider loops, compare the outer most ends of the segment:
		// - first stop for start location
		// - last stop for end location

		const [startStop] = route.stops
			?.filter(s => s.locationId === startLocationId)
			?.sort(compareFnByNumberAsc(item => item.order));

		const [endStop] = route.stops
			?.filter(s => s.locationId === endLocationId)
			?.sort(compareFnByNumberAsc(item => item.order, true));

		if (startStop && endStop) {
			if (startStop.order < endStop.order) {
				validRoutes.add(route);
			}
		}
	}

	return Array.from(validRoutes.values());
};
